var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStars = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "stars_svg__a",
  width: 20,
  height: 20,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h20v20H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#stars_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FDCC0D",
  d: "m4.854 17.5 1.354-5.854-4.541-3.938 6-.52L10 1.666l2.333 5.52 6 .521-4.541 3.938 1.354 5.854L10 14.396z"
}))));
export default SvgStars;